import { MousePointer2, Move, PenLine, CircleDot, Play, Undo2, Redo2, RotateCcw } from "lucide-react";
import { BALL_STYLES } from "@/lib/playStyles";
import { playerById } from "@/lib/playEngine";

export const TOOLS = [
  { id: "select", label: "Select/Edit Player", icon: MousePointer2 },
  { id: "move", label: "Move Player", icon: Move },
  { id: "route", label: "Draw/Edit Route", icon: PenLine },
  { id: "ball", label: "Ball Action", icon: CircleDot },
  { id: "preview", label: "Preview", icon: Play },
];

export function ToolBar({ tool, setTool, hist }) {
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="editor-toolbar">
      <div className="flex flex-wrap gap-1.5 flex-1" role="toolbar" aria-label="Editor tools">
        {TOOLS.map((t) => (
          <button key={t.id} onClick={() => setTool(t.id)} aria-pressed={tool === t.id} className={`btn px-3 ${tool === t.id ? "btn-primary" : "btn-ghost"}`} data-testid={`tool-${t.id === "move" ? "move-player" : t.id === "route" ? "draw-route" : t.id === "ball" ? "ball-action" : t.id}`}>
            <t.icon size={18} /><span className="text-xs sm:text-sm">{t.label}</span>
          </button>
        ))}
      </div>
      <div className="flex gap-1.5">
        <button className="btn btn-ghost px-3" onClick={hist.undo} disabled={!hist.canUndo} aria-label="Undo" data-testid="btn-undo-action"><Undo2 size={18} /></button>
        <button className="btn btn-ghost px-3" onClick={hist.redo} disabled={!hist.canRedo} aria-label="Redo" data-testid="btn-redo-action"><Redo2 size={18} /></button>
      </div>
    </div>
  );
}

function Chips({ items, value, onChange, testId }) {
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testId}>
      {Object.entries(items).map(([k, s]) => (
        <button key={k} onClick={() => onChange(k)} aria-pressed={value === k} className={`chip ${value === k ? "chip-on" : ""}`} data-testid={`${testId}-${k}`}>{s.label}</button>
      ))}
    </div>
  );
}

const Hint = ({ children }) => <p className="text-sm text-slate-300" data-testid="tool-hint">{children}</p>;

export function ToolOptions({ tool, play, ballType, setBallType, ballFrom, setBallFrom, onRestore, onQuizDone, routeTools }) {
  if (tool === "select") return <Hint>Tap a player to edit their label, number, instructions and timing. Dragging is turned off in this tool.</Hint>;
  if (tool === "move") return (
    <div className="flex flex-wrap items-center gap-3"><Hint>Drag players to set the starting formation. Their routes move with them.</Hint>
      <button className="btn btn-ghost" onClick={onRestore} data-testid="btn-restore-formation"><RotateCcw size={16} />Restore formation</button></div>
  );
  if (tool === "route") return routeTools;
  if (tool === "ball") return (
    <div className="space-y-2">
      <Chips items={BALL_STYLES} value={ballType} onChange={setBallType} testId="ball-type" />
      <div className="flex flex-wrap items-center gap-2">
        <Hint>{ballFrom ? `${BALL_STYLES[ballType].label} from ${playerById(play, ballFrom)?.label}: now tap the player who gets the ball.` : `Tap the player who has the ball for the ${BALL_STYLES[ballType].label.toLowerCase()}.`}</Hint>
        {ballFrom && <button className="btn btn-ghost" onClick={() => setBallFrom(null)} data-testid="btn-cancel-ball">Cancel</button>}
      </div>
    </div>
  );
  if (tool === "quiz") return (
    <div className="flex flex-wrap items-center gap-3"><Hint>Tap the field where the right answer is. The yellow circle shows the target area.</Hint>
      <button className="btn btn-primary" onClick={onQuizDone} data-testid="btn-quiz-target-done">Done</button></div>
  );
  return null;
}
